module.exports = __webpack_public_path__ + "static/media/vs-code.11c4184e.png";